import '/assets/styles/partials/pricebox.scss';
import classNames from 'classnames';
import Placeholder from '/views/partials/placeholder';
import { useMemo } from 'react';

// Functions
import formatNumber from '@wearetla/tla-essentials-tools/functions/format-number';

const Pricebox = ({ price: rawPrice, product, horizontal, colored, className }) => {
	const price = useMemo(() => {
		if ((typeof rawPrice === 'string' || typeof rawPrice === 'number') && !isNaN(rawPrice)) {
			return {
				currency_prefix: null,
				currency_suffix: 'TL',
				price: parseFloat(rawPrice),
				price_formatted: rawPrice.toString().replace('.', ','),
				old_price: null,
				old_price_formatted: null,
			};
		} else if (product?.price) {
			const price = parseFloat(product.price);
			const oldPrice = parseFloat(product.old_price);

			return {
				currency_prefix: null,
				currency_suffix: 'TL',
				price: price,
				price_formatted: formatNumber(price),
				old_price: oldPrice,
				old_price_formatted: formatNumber(oldPrice),
			};
		} else if (rawPrice?.price && rawPrice.price_formatted) {
			return rawPrice;
		}

		return false;
	}, [product, rawPrice]);

	if (price === false) {
		return (
			<span className={classNames('pricebox', className)}>
				<Placeholder className="pricebox-price new" />
			</span>
		);
	}

	if (price?.price_formatted) {
		return (
			<span
				className={classNames('pricebox', className, {
					vertical: !horizontal,
					horizontal,
					colored,
				})}
			>
				{!!(price.old_price && price.old_price !== price.price) && (
					<span className="pricebox-price old">
						{price.currency_prefix && (
							<span className="pricebox-currency prefix">{price.currency_prefix}</span>
						)}
						{price.old_price_formatted}
						{price.currency_suffix && (
							<span className="pricebox-currency suffix">{price.currency_suffix}</span>
						)}
					</span>
				)}
				<span className="pricebox-price new">
					{price.currency_prefix && (
						<span className="pricebox-currency prefix">{price.currency_prefix}</span>
					)}
					{price.price_formatted}
					{price.currency_suffix && (
						<span className="pricebox-currency suffix">{price.currency_suffix}</span>
					)}
				</span>
			</span>
		);
	} else {
		return null;
	}
};

export default Pricebox;
